import { Layout } from "antd";
import React, { useState, useEffect } from "react";

import FormPart from "./FormPart";
import SignInForm from "./SignInForm";
import StepNavigation from "./StepNavigation";
import FormProgress from "./FormProgress";
import SiteFooter from "./SiteFooter";
import SiteHeader from "./SiteHeader";
import StripeCheckout from "./StripeCheckout";
import PaymentStatusPage from "./PaymentStatusPage";
import ApplicationStatusPage from "./ApplicationStatusPage";

const { Content } = Layout;

function MainPage(props) {
  const [form, setForm] = useState("Loading One Moment...");
  const [progress, setProgress] = useState([]);
  const [menu, setMenu] = useState([]);
  const [activeMenuItem, setActiveMenuItem] = useState("sub_sub1_1");
  const [formData, setFormData] = useState("");
  const [canGoBack, setCanGoBack] = useState(false);
  const [previousFormId, setPreviousFormId] = useState("1_1");
  const [openMenu, setOpenMenu] = useState([]);
  const [welcomeMessage, setWelcomeMessage] = useState("");
  const [applicationHeader, setApplicationHeader] = useState("");

  const [currentFormId, setCurrentFormId] = useState("1_1");
  const [stripeClientSecret, setStripeClientSecret] = useState("");
  const [stripePublicKey, setStripePublicKey] = useState("");
  const [openMobileMenu, setOpenMobileMenu] = useState(false);

  const onMobileMenuClose = () => {
    setOpenMobileMenu(!openMenu);
  };
  useEffect(() => {
    const _currentFormId = JSON.parse(localStorage.getItem("currentFormId"));
    const _stripeClientSecret = JSON.parse(
      localStorage.getItem("stripeClientSecret")
    );
    const _stripePublicKey = JSON.parse(
      localStorage.getItem("stripePublicKey")
    );
    if (_currentFormId) setCurrentFormId(_currentFormId);
    if (_stripeClientSecret) setStripeClientSecret(_stripeClientSecret);
    if (_stripePublicKey) setStripePublicKey(_stripePublicKey);
  }, []);
  const contentToRender = (formId) => {
    switch (formId) {
      case "4_1":
        return (
          <StripeCheckout
            publicKey={stripePublicKey}
            clientSecret={stripeClientSecret}
            setSpin={props.setSpin}
            form={form}
            formData={formData}
            canGoBack={canGoBack}
            previousFormId={previousFormId}
            setActiveMenuItem={setActiveMenuItem}
            setCanGoBack={setCanGoBack}
            setForm={setForm}
            setFormData={setFormData}
            setMenu={setMenu}
            setOpenMenu={setOpenMenu}
            setPreviousFormId={setPreviousFormId}
            setProgress={setProgress}
            setCurrentFormId={setCurrentFormId}
          />
        );
      case "4_2":
        return <PaymentStatusPage />;
      case "5_1":
      case "5_2":
      case "5_3":
        return <ApplicationStatusPage stage={formId} />;
      default:
        return (
          <FormPart
            form={form}
            formData={formData}
            canGoBack={canGoBack}
            previousFormId={previousFormId}
            setActiveMenuItem={setActiveMenuItem}
            setCanGoBack={setCanGoBack}
            setSpin={props.setSpin}
            setForm={setForm}
            setFormData={setFormData}
            setMenu={setMenu}
            setOpenMenu={setOpenMenu}
            setPreviousFormId={setPreviousFormId}
            setProgress={setProgress}
            setCurrentFormId={setCurrentFormId}
            setStripeClientSecret={setStripeClientSecret}
            setStripePublicKey={setStripePublicKey}
          />
        );
    }
  };
  return (
    <>
      {props.loggedIn ? (
        <StepNavigation
          menu={menu}
          activeMenuItem={activeMenuItem}
          setOpenMenu={setOpenMenu}
          openMenu={openMenu}
          setActiveMenuItem={setActiveMenuItem}
          progress={progress}
          setCanGoBack={setCanGoBack}
          setSpin={props.setSpin}
          setForm={setForm}
          setMenu={setMenu}
          setProgress={setProgress}
          setFormData={setFormData}
          setPreviousFormId={setPreviousFormId}
          setCurrentFormId={setCurrentFormId}
          openMobileMenu={openMobileMenu}
          onMobileMenuClose={onMobileMenuClose}
          setOpenMobileMenu={setOpenMobileMenu}
          applicationHeader={applicationHeader}
        />
      ) : (
        ""
      )}
      <Layout className="site-layout">
        {props.loggedIn ? (
          <>
            <SiteHeader
              headerType="logged-in"
              loggedIn={props.loggedIn}
              welcomeMessage={welcomeMessage}
              applicationHeader={applicationHeader}
              setOpenMobileMenu={setOpenMobileMenu}
            />
            <Content style={{ margin: "0 16px", paddingTop: "25px" }}>
              <FormProgress menu={menu} progress={progress} />
              {contentToRender(currentFormId)}
            </Content>
          </>
        ) : (
          <React.Fragment key="202">
            <SiteHeader
              headerType="logged-out"
              loggedIn={props.loggedIn}
              welcomeMessage={welcomeMessage}
            />
            <SignInForm
              setCanGoBack={setCanGoBack}
              setForm={setForm}
              setFormData={setFormData}
              setLoggedIn={props.setLoggedIn}
              setMenu={setMenu}
              setSpin={props.setSpin}
              setProgress={setProgress}
              setOpenMenu={setOpenMenu}
              form={form}
              setPreviousFormId={setPreviousFormId}
              setActiveMenuItem={setActiveMenuItem}
              setWelcomeMessage={setWelcomeMessage}
              setApplicationHeader={setApplicationHeader}
              setCurrentFormId={setCurrentFormId}
              setStripeClientSecret={setStripeClientSecret}
              setStripePublicKey={setStripePublicKey}
            />
          </React.Fragment>
        )}
        <SiteFooter />
      </Layout>
    </>
  );
}

export default MainPage;
